import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
/* eslint-disable */
import editorStyle from "../util/defaultStyle";
import { getShapeName } from '../util/clazz';
export default function (G6) {
  G6.registerBehavior('dragPanelItemAddNode', {
    getDefaultCfg: function getDefaultCfg() {
      return {};
    },
    getEvents: function getEvents() {
      return {
        'canvas:mousemove': 'onMouseMove',
        'canvas:mouseup': 'onMouseUp',
        'canvas:mouseleave': 'onMouseLeave'
      };
    },
    onMouseMove: function onMouseMove(e) {
      if (this.graph.get('addNodeDragging')) {
        var delegateShape = this.graph.get('addDelegateShape');
        var addModel = this.graph.get('addModel');
        var width = parseInt(addModel.size.split('*')[0]);
        var height = parseInt(addModel.size.split('*')[1]);
        var point = this.graph.getPointByClient(e.x, e.y);
        var x = point.x;
        var y = point.y;
        if (!delegateShape) {
          var parent = this.graph.get('group');
          delegateShape = parent.addShape('rect', {
            attrs: _objectSpread({
              width: width,
              height: height,
              x: x - width / 2,
              y: y - height / 2
            }, editorStyle.nodeDelegationStyle)
          });
          delegateShape.set('capture', false);
          this.graph.set('addDelegateShape', delegateShape);
        }
        delegateShape.attr({
          x: x - width / 2,
          y: y - height / 2
        });
        this.graph.paint();
        this.graph.emit('afternodedrag', delegateShape);
      }
    },
    onMouseUp: function onMouseUp(e) {
      if (this.graph.get('addNodeDragging')) {
        var p = this.graph.getPointByClient(e.clientX, e.clientY);
        var subProcessNode = this.graph.find('node', function (node) {
          if (node.get('model')) {
            var clazz = node.get('model').clazz;
            if (clazz === 'subProcess') {
              var bbox = node.getBBox();
              return p.x > bbox.minX && bbox.maxX > p.x && p.y > bbox.minY && bbox.maxY > p.y;
            }
          } else {
            return false;
          }
        });
        if (subProcessNode) {
          if (p.x > 0 && p.y > 0) {
            this._addNodeBySubProcess(p, subProcessNode);
          }
        } else {
          if (p.x > 0 && p.y > 0) {
            this._addNode(p);
          }
        }
      }
    },
    _addNodeBySubProcess: function _addNodeBySubProcess(p, node) {
      if (this.graph.get('addNodeDragging')) {
        var addModel = this.graph.get('addModel');
        var _addModel$clazz = addModel.clazz,
          clazz = _addModel$clazz === void 0 ? 'userTask' : _addModel$clazz;
        addModel.shape = getShapeName(clazz);
        addModel.size = addModel.size.split("*");
        var timestamp = new Date().getTime();
        var id = clazz + timestamp;
        var bbox = node.getBBox();
        var x = p.x - bbox.x - bbox.width / 2;
        var y = p.y - bbox.y - bbox.height / 2;
        var nodeCfg = _objectSpread(_objectSpread({}, addModel), {}, {
          x: x,
          y: y,
          id: id
        });
        var group = node.getContainer();
        var resultModel = group.addNodeModel(node, nodeCfg);
        if (this.graph.executeCommand) {
          this.graph.executeCommand('update', {
            itemId: node.get('id'),
            updateModel: resultModel
          });
        } else {
          this.graph.updateItem(node, resultModel);
        }
      }
    },
    onMouseLeave: function onMouseLeave(e) {
      if (this.graph.get('addNodeDragging')) {
        this._clearDelegate();
        this.graph.emit('afternodedragend');
      }
    },
    _clearDelegate: function _clearDelegate() {
      var delegateShape = this.graph.get('addDelegateShape');
      if (delegateShape) {
        delegateShape.remove();
        this.graph.set('addDelegateShape', null);
        this.graph.paint();
      }
      this.graph.emit('afternodedragend');
    },
    _addNode: function _addNode(p) {
      if (this.graph.get('addNodeDragging')) {
        var addModel = this.graph.get('addModel');
        var _addModel$clazz2 = addModel.clazz,
          clazz = _addModel$clazz2 === void 0 ? 'userTask' : _addModel$clazz2;
        //type、shape属性同时存在即兼容之前版本的数据，又兼容g6的升级
        addModel.type = getShapeName(clazz);
        addModel.shape = getShapeName(clazz);
        addModel.hideIcon = false;
        var timestamp = new Date().getTime();
        var id = clazz + timestamp;
        var x = p.x;
        var y = p.y;
        if (this.graph.executeCommand) {
          this.graph.executeCommand('add', {
            type: 'node',
            addModel: _objectSpread(_objectSpread({}, addModel), {}, {
              x: x,
              y: y,
              id: id
            })
          });
        } else {
          this.graph.add('node', _objectSpread(_objectSpread({}, addModel), {}, {
            x: x,
            y: y,
            id: id
          }));
        }
        this._clearDelegate();
      }
    }
  });
}